import InterfaceSwitcher, { userInterfacePT } from './InterfaceSwitcher';

export const userInterfaceType = userInterfacePT;

export default InterfaceSwitcher;
